import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_store_interaction } from '../../_fields/_base/_enums/ENUM__field_store_interaction';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__field_role } from '../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_SPANDREL__upscaler extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_SPANDREL__UPSCALER;

  /*
   * FIELDS
   */

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_input_with_type(ENUM__ml_asset_type.VISION, { field_role: ENUM__field_role.MODEL__UPSCALER })
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__image_asset.init_as_input_transform_none({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input(
    {
      value: 512,
      value_range: new DTO__number_range(0, 1024),
      values_allowed: new DTO__number_range(0, 1024),
      //
      multiple_of: 512,
      //
      slider_step: 512,
      slider_step_values: [512],
    },
    {
      field_role: ENUM__field_role.TILE_SIZE,
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
      store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
    },
  )
  tile_size!: FIELD_PRIMITIVE__int;

  /*
   *
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE }, { field_role: '🖼️ Image Upscaled' })
  image_out!: FIELD__image_asset;

  /*
   * PROPERTIES
   */

  get family() {
    return ENUM__ml_asset_family.VISION_SPANDREL__UPSCALER;
  }

  /*
   * METHODS
   */

  constructor(type = ENUM__invocation_type.SPANDREL__UPSCALER) {
    super(type);
  }
}
